// Timeline Service - Gestión de eventos cronológicos del caso
import { db } from './firebase.js';
import { collection, addDoc, getDocs, query, where, orderBy, updateDoc, doc, deleteDoc } from 'firebase/firestore';

export const TimelineService = {
    // Crear un nuevo evento en la timeline
    async createEvent(caseId, eventData) {
        try {
            const event = {
                caseId,
                ...eventData,
                createdAt: new Date(),
                updatedAt: new Date()
            };

            const docRef = await addDoc(collection(db, `cases/${caseId}/timeline`), event);
            return { id: docRef.id, ...event };
        } catch (e) {
            console.error("Error creando evento:", e);
            throw e;
        }
    },

    // Obtener todos los eventos de un caso
    async getEvents(caseId) {
        try {
            const q = query(
                collection(db, `cases/${caseId}/timeline`),
                orderBy('date', 'asc')
            );

            const snapshot = await getDocs(q);
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        } catch (e) {
            console.error("Error obteniendo eventos:", e);
            return [];
        }
    },

    // Actualizar un evento
    async updateEvent(caseId, eventId, updates) {
        try {
            const eventRef = doc(db, `cases/${caseId}/timeline`, eventId);
            await updateDoc(eventRef, {
                ...updates,
                updatedAt: new Date()
            });
        } catch (e) {
            console.error("Error actualizando evento:", e);
            throw e;
        }
    },

    // Eliminar un evento
    async deleteEvent(caseId, eventId) {
        try {
            await deleteDoc(doc(db, `cases/${caseId}/timeline`, eventId));
        } catch (e) {
            console.error("Error eliminando evento:", e);
            throw e;
        }
    },

    // Crear eventos automáticamente desde documentos existentes
    async syncFromActions(caseId, actions) {
        try {
            const events = [];

            for (const action of actions) {
                // Determinar tipo de evento basado en categoría
                let eventType = 'document';
                let eventColor = '#60a5fa'; // Azul por defecto

                if (action.category && action.category.includes('RESOLUCIONES')) {
                    eventType = 'sentencia';
                    eventColor = '#facc15'; // Dorado
                } else if (action.category && action.category.includes('PRUEBAS')) {
                    eventType = 'prueba';
                    eventColor = '#10b981'; // Verde
                } else if (action.category && action.category.includes('NOTIFICACIONES')) {
                    eventType = 'notificacion';
                    eventColor = '#3b82f6'; // Azul
                }

                const event = {
                    title: action.title,
                    description: action.description || '',
                    date: action.timestamp || action.createdAt,
                    type: eventType,
                    color: eventColor,
                    documents: [{
                        id: action.id,
                        name: action.driveFileName || action.title,
                        link: action.driveFileLink
                    }],
                    isFuture: false,
                    isCertain: true
                };

                events.push(await this.createEvent(caseId, event));
            }

            return events;
        } catch (e) {
            console.error("Error sincronizando eventos:", e);
            throw e;
        }
    }
};
